<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl=""></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/myPartner">我的团队</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="leftMenu">
						<p @click="toMyPage('myOrder')">
							<i class="el-icon-s-unfold"></i> 我的订单
						</p>
						<p @click="toMyPage('myCourse')">
							<i class="el-icon-menu"></i> 我的课程
						</p>
						<p @click="toMyPage('myCollect')">
							<i class="el-icon-star-on"></i> 我的收藏
						</p>
						<p class="sel">
							<i class="el-icon-s-custom"></i> 我的团队
						</p>
					</div>
					<div class="rightList">
						<div class="status">
							<div class="status statusSel">
								<span>我的团队</span>
								<span />
							</div>
						</div>
						<div class="list" v-if="partnerList&&partnerList.length">
							<el-table :data="partnerList" style="width: 100%" row-key="id" border lazy :load="load"
								:tree-props="{children: 'children', hasChildren: 'children'}">
								<el-table-column prop="nickname" label="昵称" width="180">
									<template slot-scope="scope">
										<span>{{ scope.row.nickname || scope.row.username || '昵称'}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="nickname" label="头像" width="80">
									<template slot-scope="scope">
										<img style="width: 30px;border-radius: 50%;" :src="scope.row.avatar"></img>
									</template>
								</el-table-column>
								<el-table-column prop="tag" label="标签" width="100"
									:filters="[{ text: '队员', value: '0' }, { text: '乐商', value: '1' }]" :filter-method="filterTag"
									filter-placement="bottom-end">
									<template slot-scope="scope">
										<el-tag :type="scope.row.is_sale === '1' ? 'success' : 'info'"
											disable-transitions>{{[{ text: '队员', value: '0' }, { text: '乐商', value: '1' }][scope.row.is_sale].text}}</el-tag>
									</template>
								</el-table-column><el-table-column prop="createtime" label="加入时间" sortable width="120">
								</el-table-column>
								<el-table-column label="收益" sortable width="100">
									<template slot-scope="scope">
										<p>￥{{ scope.row.money }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="shareuser" label="备注">
								</el-table-column>
							</el-table>
						</div>
						<div v-else class="noData">
							<img src="@/assets/empty.jpg"></img>
							<span>无数据</span>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0);
			},
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>